import request from '@/utils/request'

// 查询用户信息分页
export function pageUser(query) {
  return request({
    url: '/user/user/page',
    method: 'get',
    params: query
  })
}

// 查询用户信息分页
export function pageUserInvite(query) {
  return request({
    url: '/user/user/userInvitePage',
    method: 'get',
    params: query
  })
}

// 查询用户信息分页
export function pageUserAgency(query) {
  return request({
    url: '/user/user/userAgencyPage',
    method: 'get',
    params: query
  })
}

// 查询虚拟用户信息分页
export function pageVirtualUser(query) {
  return request({
    url: '/user/user/virtualUserPage',
    method: 'get',
    params: query
  })
}

// 生成虚拟账号
export function virtualUsers(query) {
  return request({
    url: '/user/user/virtualUsers',
    method: 'get',
    params: query
  })
}

// 查询用户信息分页
export function pageUserOpen(query) {
  return request({
    url: '/user/user/openPage',
    method: 'get',
    params: query
  })
}

export function handleBan(query){
  return request({
    url: '/user/user/handleBan',
    method: 'post',
    params: query
  })
}

export function updtaeIntegral(query){
  return request({
    url: '/user/user/updtaeIntegral',
    method: 'post',
    params: query
  })
}

export function bindUserAgency(query){
  return request({
    url: '/user/user/bindUserAgency',
    method: 'post',
    params: query
  })
}

export function unBindUserAgency(query){
  return request({
    url: '/user/user/unBindUserAgency',
    method: 'post',
    params: query
  })
}

export function unbind(query){
  return request({
    url: '/user/user/unbind',
    method: 'post',
    params: query
  })
}


export function getUser(data) {
  return request({
    url: '/user/user/detail',
    method: 'get',
    params: data
  })
}
